import { CommonModule } from '@angular/common';
import {
  Component,
  input,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
import {
  CourseInfoRow,
  createCourseInfoRows,
} from '../../utils/course-info-rows.util';

/**
 * Component responsible for displaying course information
 * Follows Single Responsibility Principle - only handles course info display
 */
@Component({
  selector: 'app-course-info-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './course-info-card.component.html',
  styleUrl: './course-info-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseInfoCardComponent {
  course = input<ChallengeGen.Course | undefined>(undefined);
  tags = computed(() => this.course()?.tags || []);

  courseInfoRows = computed<CourseInfoRow[]>(() => {
    return createCourseInfoRows(() => this.course());
  });

  /**
   * Converts a value to string for use in templates
   * Needed because translate pipe requires string input
   */
  toString(value: string | number | undefined | null): string {
    return value != null ? String(value) : '';
  }
}
